import { IConfig } from '@cian/config/shared';
import { SNR_DESKTOP_SR135_REMOVE_POPULAR } from '../constants/experiments';
import { getExperimentGroup } from './getExperimentGroup';
import { IAbUseExperiment } from '../types/abUseExperiments';

type TFunctionParams = {
  experiments: IAbUseExperiment[];
  section: string;
  config: IConfig;
};

/**
 * @todo Удалить после завершения эксперимента
 * @description Данный функционал появился в задаче CD-253017, будет удалён в задаче CD-253242
 */
export const isRemovePopularExperimentEnabled = ({ experiments, section, config }: TFunctionParams): boolean => {
  const isFeatureEnabled = !!config.get('snrRemovePopularExperiment.Enabled');
  const isVisibleForCurrentSection = ['index', 'sale', 'rent'].includes(section);
  const abGroup = getExperimentGroup(experiments, SNR_DESKTOP_SR135_REMOVE_POPULAR);

  return Boolean(abGroup && abGroup !== 'A' && isVisibleForCurrentSection && isFeatureEnabled);
};
